import React, { useState, forwardRef } from 'react'
import { Input, TextareaAutosize } from '../../../components'

const _QuestionnaireNewForm = ({ submitForm, loading, setLoading }, ref) => {

  const initialFormState = { name: '', title: '', description: '' }
  const [formData, setFormData] = useState(initialFormState)
  const [invalidFields, setInvalidFields] = useState(new Set())

  const handleInputChange = (event) => {
    const { name, value } = event.target
    if (value) setInvalidFields(prev => { const next = new Set(prev); next.delete(name); return next })
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const onSubmit = (event) => {
    event.preventDefault()
    setLoading(true)

    const errs = new Set()
    if (!formData.name.trim())  errs.add('name')
    if (!formData.title.trim()) errs.add('title')

    if (errs.size > 0) {
      setInvalidFields(errs)
      setLoading(false)
      return
    }

    submitForm(formData)
    setLoading(false)
  }

  return (
    <div className="form">
      <form onSubmit={onSubmit} ref={ref}>

        <div className="form-block vertical">
          <Input type="text" name="name" label="Name" value={formData.name} onChange={handleInputChange} disabled={loading}
            placeholder="e.g. Buddy - Uppföljning"
            validation={invalidFields.has('name') ? { valid: false, message: 'Name is required' } : undefined} />
        </div>

        <div className="form-block vertical">
          <Input type="text" name="title" label="Title" value={formData.title} onChange={handleInputChange} disabled={loading}
            placeholder="Shown to the person filling it out"
            validation={invalidFields.has('title') ? { valid: false, message: 'Title is required' } : undefined} />
        </div>

        <div className="form-block vertical">
          <label>Description (optional)</label>
          <TextareaAutosize name="description" value={formData.description} onChange={handleInputChange} minRows={3} />
        </div>

      </form>
    </div>
  )
}

export const QuestionnaireNewForm = forwardRef(_QuestionnaireNewForm)
